import {GET_BREADCRUMBS, SET_BREADCRUMBS} from '../actions/types';
import initialState from './initialState';

export default (prevState = initialState.BREADCRUMBS, action) => {
    switch(action.type) {

        case GET_BREADCRUMBS:
            return prevState;
        case SET_BREADCRUMBS:
            const state = [...prevState];
            state[1] = action.product || state[1];
            state[2] = action.step || state[2];
            return state;
        default:
            return prevState;

}
}



// WEBPACK FOOTER //
// ./src/reducers/breadcrumbsReducer.js